export default __webpack_public_path__ + "static/media/pk_testing.3cabd6a0.svg";